<template>
    <div class="tx-mobile-status" v-bind:class="`tx-mobile-status--${statusName}`">
        <div v-if="traceStatus === undefined" class="tx-mobile-status__title">
            <span class="skeleton">Successful transaction</span>
        </div>
        <div v-else class="tx-mobile-status__title">
            <span v-if="statusName === 'pending'" class="tx-mobile-status__dot"/>
            {{ $t(`tx.hero_${kindName}_${statusName}`) }}
        </div>
    </div>
</template>

<script>
export default {
    props: ['traceStatus', 'isPending', 'traceActions'],
    computed: {
        statusName() {
            if (this.isPending) return 'pending';
            if (this.traceStatus) return 'success';
            return 'failed';
        },

        kindName() {
            const event = this.txDetails?.event;
            if (event === 'jetton_swap') return 'exchange';
            if (event === 'jetton_burn') return 'burn';
            if (['received_gram', 'sent_gram', 'nft_transfer', 'nft_purchase', 'sent_jetton', 'received_jetton'].includes(event)) return 'transfer';
            return 'transaction';
        },

        txDetails() {
            if (!this.traceActions) return null;

            if (this.traceActions[0]?.simple_preview) {
                return this.traceActions[0]?.simple_preview;
            }
            return this.traceActions[0];
        },
    },
};
</script>

<style scoped lang="scss">
// The outcome is the caption itself: "Failed transfer" in the status colour, no pill.
.tx-mobile-status {
    display: flex;
    align-items: center;
    min-width: 0;

    &__title {
        display: flex;
        align-items: center;
        gap: 7px;
        min-width: 0;
        font-size: 13px;
        font-weight: 600;
        letter-spacing: .04em;
        text-transform: uppercase;
        color: var(--body-muted-text-color);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    &__dot {
        flex-shrink: 0;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: currentColor;
    }

    &--success &__title {
        color: var(--green-bright);
    }

    &--failed &__title {
        color: var(--red-bright);
    }

    &--pending &__dot {
        animation: tx-status-pulse 1.4s ease-in-out infinite;
    }
}

@keyframes tx-status-pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: .35; }
}

@media (prefers-reduced-motion: reduce) {
    .tx-mobile-status--pending .tx-mobile-status__dot {
        animation: none;
    }
}
</style>
